module.exports = __webpack_public_path__ + "static/media/Maf_Masculinidad.0d040d5d.jpg";